import React, { useEffect, useState, useRef } from "react"
import { Col, Row } from "reactstrap"

import FormButtons from "components/Services/FormComponents/FormButtons"

const StepTwo = props => {
  const attachmentsFormRef = useRef(null)
  const [formBody, setformBody] = useState(<div></div>)


  useEffect(() => {
    setformBody(props.formBody)
  }, [props.formBody])

  const toggleNext = tab => {
    attachmentsFormRef.current.click()
  }

  const togglePrevious = tab => {
    props.toggleTab(1)
  }

  const toggleSubmit = tab => {}

  const prepareUploadFiles = e => {
    let current_attachments = []
    let kount = 0
    for (kount = 0; kount < props.attachments.length; kount++) {
      current_attachments.push({
        application_id: props.applicationId,
        description: e.target[kount].id,
        file: e.target[kount].files[0],
      })
    }
    props.submit(current_attachments)
  }

  return (
    <>
      <div className="mb-5">
        <form
          onSubmit={e => {
            e.preventDefault()
            prepareUploadFiles(e)
          }}
        >
          {formBody}

          <Row style={{ display: "none" }}>
            <Col md={12}>
              <button ref={attachmentsFormRef} type="submit">
                Upload Attachments
              </button>
            </Col>
          </Row>
        </form>
      </div>
      <FormButtons
        activeTab={2}
        toggleNext={toggleNext}
        togglePrevious={togglePrevious}
        toggleSubmit={toggleSubmit}
      />
    </>
  )
}

export default StepTwo
